import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { LegendaryGame } from './legendary-game.interface';
import { AuthorizationService } from '../services/authorization.service';
import { LegendaryService } from '../services/legendary.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'randomizer-form',
    template: require('./randomizer-form.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class RandomizerFormComponent {
    randomizerForm: FormGroup;
    game: LegendaryGame;
    counter: number = 0;

    loggedIn: boolean = false;
    useCustom: boolean = false;
    windowWidth: number;
    _menuOpen: boolean = true;

    constructor(private fb: FormBuilder, private auth: AuthorizationService, private legendaryService: LegendaryService) {
        this.loggedIn = auth.isLoggedIn();
        this.windowWidth = document.documentElement.clientWidth;

        this.createForm();
    }

    ngOnInit() {
        this.legendaryService.fetchControls()
            .subscribe(settings => {
                this.useCustom = settings.useCustom;
                this.schemeList = settings.schemeList;
                this.mastermindList = settings.mastermindList;
                this.heroTeamList = settings.heroTeamList;
                this.villainList = settings.villainList;
                this.villainFilter = settings.villainFilter;
                this.henchmenList = settings.henchmenList;
                this.henchmenFilter = settings.henchmenFilter;
                this.heroList = settings.heroList;
                this.heroFilter = settings.heroFilter;
                this.mastermindExcludeList = settings.mastermindExcludeList;
                this.mastermindExcludeFilter = settings.mastermindExcludeFilter;
                this.schemeExcludeList = settings.schemeExcludeList;
                this.schemeExcludeFilter = settings.schemeExcludeFilter;
            })

        this.legendaryService.fetchMarvelSettings()
            .subscribe(settings => {
                this.randomizerForm.patchValue({
                    Players: settings.Players,
                    PlayableMastermind: settings.PlayableMastermind,
                    PlayableMastermindDeck: settings.PlayableMastermindDeck,
                    LegendarySets: {
                        Core: (settings.LegendarySets.indexOf("Core") > -1) ? false : true,
                        DarkCity: (settings.LegendarySets.indexOf("DarkCity") > -1) ? false : true,
                        FantasticFour: (settings.LegendarySets.indexOf("FantasticFour") > -1) ? false : true,
                        PaintTheTownRed: (settings.LegendarySets.indexOf("PaintTheTownRed") > -1) ? false : true,
                        GuardiansOfTheGalaxy: (settings.LegendarySets.indexOf("GuardiansOfTheGalaxy") > -1) ? false : true,
                        SecretWarsVol1: (settings.LegendarySets.indexOf("SecretWarsVol1") > -1) ? false : true,
                        SecretWarsVol2: (settings.LegendarySets.indexOf("SecretWarsVol2") > -1) ? false : true,
                        CaptainAmerica: (settings.LegendarySets.indexOf("CaptainAmerica") > -1) ? false : true,
                        CivilWar: (settings.LegendarySets.indexOf("CivilWar") > -1) ? false : true,
                        Deadpool: (settings.LegendarySets.indexOf("Deadpool") > -1) ? false : true,
                        Noir: (settings.LegendarySets.indexOf("Noir") > -1) ? false : true,
                        XMen: (settings.LegendarySets.indexOf("XMen") > -1) ? false : true,
                        Homecoming: (settings.LegendarySets.indexOf("Homecoming") > -1) ? false : true,
                        Champions: (settings.LegendarySets.indexOf("Champions") > -1) ? false : true,
                        WorldWarHulk: (settings.LegendarySets.indexOf("WorldWarHulk") > -1) ? false : true,
                        Phase1: (settings.LegendarySets.indexOf("Phase1") > -1) ? false : true,
                        AntMan: (settings.LegendarySets.indexOf("AntMan") > -1) ? false : true,
                        VillainsSet: (settings.LegendarySets.indexOf("VillainsSet") > -1) ? false : true,
                        FearItselfSet: (settings.LegendarySets.indexOf("FearItselfSet") > -1) ? false : true,
                        BigTrouble: (settings.LegendarySets.indexOf("BigTrouble") > -1) ? false : true,
                        Buffy: (settings.LegendarySets.indexOf("Buffy") > -1) ? false : true,
                        CustomSet: (settings.LegendarySets.indexOf("CustomSet") > -1) ? false : true,
                    },
                    ChallengeMode: settings.ChallengeMode,
                    MastermindDifficulty: settings.MastermindDifficulty,
                    TransmogrifiedScheme: settings.TransmogrifiedScheme,
                    TransmogrifiedMastermind: settings.TransmogrifiedMastermind,
                    AllyMatchMastermind: settings.AllyMatchMastermind,
                    TransmogrifiedMastermindDeck1: settings.TransmogrifiedMastermindDeck1,
                    TransmogrifiedMastermindDeck2: settings.TransmogrifiedMastermindDeck2,
                    TransmogrifiedMastermindDeck3: settings.TransmogrifiedMastermindDeck3,
                    TransmogrifiedVillainsSetting: settings.TransmogrifiedVillainsSetting,
                    TransmogrifiedVillains: settings.TransmogrifiedVillains,
                    TransmogrifiedHenchmenSetting: settings.TransmogrifiedHenchmenSetting,
                    TransmogrifiedHenchmen: settings.TransmogrifiedHenchmen,
                    TransmogrifiedHero1: settings.TransmogrifiedHero1,
                    TransmogrifiedHero2: settings.TransmogrifiedHero2,
                    TransmogrifiedHero3: settings.TransmogrifiedHero3,
                    TransmogrifiedHero4: settings.TransmogrifiedHero4,
                    TransmogrifiedHero5: settings.TransmogrifiedHero5,
                    TransmogrifiedHero6: settings.TransmogrifiedHero6,
                    HeroOpposeMastermind: settings.HeroOpposeMastermind,
                    ExcludeMastermind: settings.ExcludeMastermind,
                    ExcludeSchemes: settings.ExcludeSchemes,
                    ExcludeHenchmen: settings.ExcludeHenchmen,
                    ExcludeVillains: settings.ExcludeVillains,
                    ExcludeHeroes: settings.ExcludeHeroes
                });
            })
    }

    createForm() {
        this.randomizerForm = this.fb.group({
            Players: 2,
            PlayableMastermind: false,
            PlayableMastermindDeck: false,
            LegendarySets: this.fb.group({
                Core: true,
                DarkCity: true,
                FantasticFour: true,
                PaintTheTownRed: true,
                GuardiansOfTheGalaxy: true,
                SecretWarsVol1: true,
                SecretWarsVol2: true,
                CaptainAmerica: true,
                CivilWar: true,
                Deadpool: true,
                Noir: true,
                XMen: true,
                Homecoming: true,
                Champions: true,
                WorldWarHulk: true,
                Phase1: true,
                AntMan: true,
                VillainsSet: true,
                FearItselfSet: true,
                BigTrouble: true,
                Buffy: true,
                CustomSet: true
            }),
            ChallengeMode: "Normal",
            MastermindDifficulty: "Standard",
            TransmogrifiedScheme: "Random",
            TransmogrifiedMastermind: "Random",
            AllyMatchMastermind: false,
            TransmogrifiedMastermindDeck1: "Random",
            TransmogrifiedMastermindDeck2: "Random",
            TransmogrifiedMastermindDeck3: "Random",
            TransmogrifiedVillainsSetting: "All",
            TransmogrifiedVillains: "",
            TransmogrifiedHenchmenSetting: "All",
            TransmogrifiedHenchmen: "",
            TransmogrifiedHero1: "Random",
            TransmogrifiedHero2: "Random",
            TransmogrifiedHero3: "Random",
            TransmogrifiedHero4: "Random",
            TransmogrifiedHero5: "Random",
            TransmogrifiedHero6: "Random",
            HeroOpposeMastermind: false,
            ExcludeMastermind: "",
            ExcludeSchemes: "",
            ExcludeHenchmen: "",
            ExcludeVillains: "",
            ExcludeHeroes: ""
        });
    }

    public playersList: Array<{ text: string, value: number }> = [
        { text: "1 Adv", value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
    ]

    public challengeList: Array<{ text: string, value: string }> = [
        { text: "Normal", value: "Normal" },
        { text: "Heroic", value: "Heroic" },
        { text: "Champion", value: "Champion" },
        { text: "Legendary", value: "Legendary" },
    ]

    public difficultyList: Array<{ text: string, value: string }> = [
        { text: "Distracted", value: "Distracted" },
        { text: "Standard", value: "Standard" },
        { text: "Maniacal", value: "Maniacal" },
        { text: "Enraged", value: "Enraged" },
        { text: "Tyrant", value: "Tyrant" },
        { text: "Nightmare", value: "Nightmare" },
        { text: "All-Powerful", value: "All-Powerful" },
    ]

    public villainSettingList: Array<string> = ["All", "Villain", "Adversary", "Match"]
    public henchmenSettingList: Array<string> = ["All", "Henchmen", "Backup", "Match"]

    public schemeList: Array<string> = [];
    public mastermindList: Array<string> = [];
    public heroTeamList: Array<string> = [];
    public villainList: Array<string> = [];
    public villainFilter: Array<string> = [];
    public henchmenList: Array<string> = [];
    public henchmenFilter: Array<string> = [];
    public heroList: Array<string> = [];
    public heroFilter: Array<string> = [];
    public mastermindExcludeList: Array<string> = [];
    public mastermindExcludeFilter: Array<string> = [];
    public schemeExcludeList: Array<string> = [];
    public schemeExcludeFilter: Array<string> = [];

    onSubmit() {
        if (this.windowWidth < 600) {
            this.toggleSidebar();
        }

        this.legendaryService.legendaryRandomize(this.randomizerForm.value)
            .subscribe((data) => {
                this.game = null;
                this.game = data as LegendaryGame;
                this.counter++;
            })
    }

    clearBaseSets() {
        this.randomizerForm.patchValue({
            LegendarySets: {
                Core: false,
                DarkCity: false,
                FantasticFour: false,
                PaintTheTownRed: false,
                GuardiansOfTheGalaxy: false,
                SecretWarsVol1: false,
                SecretWarsVol2: false,
                CaptainAmerica: false,
                CivilWar: false,
                Deadpool: false,
                Noir: false,
                XMen: false,
                Homecoming: false,
                Champions: false,
                WorldWarHulk: false,
                Phase1: false,
                AntMan: false
            }
        });
    }

    addBaseSets() {
        this.randomizerForm.patchValue({
            LegendarySets: {
                Core: true,
                DarkCity: true,
                FantasticFour: true,
                PaintTheTownRed: true,
                GuardiansOfTheGalaxy: true,
                SecretWarsVol1: true,
                SecretWarsVol2: true,
                CaptainAmerica: true,
                CivilWar: true,
                Deadpool: true,
                Noir: true,
                XMen: true,
                Homecoming: true,
                Champions: true,
                WorldWarHulk: true,
                Phase1: true,
                AntMan: true
            }
        });
    }

    clearVillainSets() {
        this.randomizerForm.patchValue({
            LegendarySets: {
                VillainsSet: false,
                FearItselfSet: false
            }
        });
    }

    addVillainSets() {
        this.randomizerForm.patchValue({
            LegendarySets: {
                VillainsSet: true,
                FearItselfSet: true
            }
        });
    }

    public handleVillainFilter(value: string) {
        this.villainFilter = this.villainList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleHenchmenFilter(value: string) {
        this.henchmenFilter = this.henchmenList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleMastermindFilter(value: string) {
        this.mastermindExcludeFilter = this.mastermindExcludeList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleSchemeFilter(value: string) {
        this.schemeExcludeFilter = this.schemeExcludeList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleHeroFilter(value: string) {
        this.heroFilter = this.heroList.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    public handleToggleSidebar() {
        this.toggleSidebar();
    }

    private toggleSidebar() {
        this._menuOpen = !this._menuOpen;
    }

    public handleAddExcluded(currentGame: LegendaryGame) {
        // check if value already in array
        // push onto array
        let mastermindExclude = this.randomizerForm.controls['ExcludeMastermind'].value;
        let schemesExclude = this.randomizerForm.controls['ExcludeSchemes'].value;
        let henchmenExclude = this.randomizerForm.controls['ExcludeHenchmen'].value;
        let villainExclude = this.randomizerForm.controls['ExcludeVillains'].value;
        let heroesExclude = this.randomizerForm.controls['ExcludeHeroes'].value;

        if (mastermindExclude == null) {
            mastermindExclude = [] as string[];
        }
        if (schemesExclude == null) {
            schemesExclude = [] as string[];
        }
        if (henchmenExclude == null) {
            henchmenExclude = [] as string[];
        }
        if (villainExclude == null) {
            villainExclude = [] as string[];
        }
        if (heroesExclude == null) {
            heroesExclude = [] as string[];
        }

        if (mastermindExclude.indexOf(currentGame.MasterMind) === -1) {
            mastermindExclude.push(currentGame.MasterMind.Name)
        }
        if (currentGame.SecondMasterMind != null && mastermindExclude.indexOf(currentGame.SecondMasterMind) === -1) {
            mastermindExclude.push(currentGame.SecondMasterMind.Name)
        }
        if (currentGame.ThirdMasterMind != null && mastermindExclude.indexOf(currentGame.ThirdMasterMind) === -1) {
            mastermindExclude.push(currentGame.ThirdMasterMind.Name)
        }
        if (currentGame.FourthMasterMind != null && mastermindExclude.indexOf(currentGame.FourthMasterMind) === -1) {
            mastermindExclude.push(currentGame.FourthMasterMind.Name)
        }

        if (schemesExclude.indexOf(currentGame.SchemeName) === -1) {
            schemesExclude.push(currentGame.SchemeName)
        }

        if (currentGame.heroDeck.Henchmen != null) {
            for (let henchmen of currentGame.heroDeck.Henchmen) {
                if (henchmen.Henchmen) {
                    if (henchmenExclude.indexOf(henchmen.Name) === -1) {
                        henchmenExclude.push(henchmen.Name)
                    }
                }
                else {
                    if (villainExclude.indexOf(henchmen.Name) === -1) {
                        villainExclude.push(henchmen.Name)
                    }
                }
            }
        }

        for (let henchmen of currentGame.villianDeck.henchmen) {

            if (henchmenExclude.indexOf(henchmen.Name) === -1) {
                henchmenExclude.push(henchmen.Name)
            }
        }

        for (let villain of currentGame.villianDeck.villains) {

            if (villainExclude.indexOf(villain.Name) === -1) {
                villainExclude.push(villain.Name)
            }
        }

        if (currentGame.villianDeck.heroes != null) {
            for (let hero of currentGame.villianDeck.heroes) {
                if (heroesExclude.indexOf(hero.Name) === -1) {
                    heroesExclude.push(hero.Name)
                }
            }
        }

        for (let hero of currentGame.heroDeck.Heroes) {

            if (heroesExclude.indexOf(hero.Name) === -1) {
                heroesExclude.push(hero.Name)
            }
        }

        this.randomizerForm.patchValue({
            ExcludeMastermind: mastermindExclude,
            ExcludeSchemes: schemesExclude,
            ExcludeHenchmen: henchmenExclude,
            ExcludeVillains: villainExclude,
            ExcludeHeroes: heroesExclude
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/legendary/randomizer-form.component.ts